import store, { reset } from "../../store";

export const resetState = () => store.dispatch(reset());
